<template>
  <div class="online-list">
    <div class="online-area">
      <button @click="$emit('back')">Back</button>
      <!-- // -->
      <!-- <pre>{{ info }}</pre> -->

      <h2>Online List</h2>
      <hr>
      <ul>
        <li :key="user.deviceID" v-for="user in info.kUsers">
          <div class="online-item">@{{ user.nickname }}</div>
          <!-- <span class="online-id">Random Browser ID: {{ user.deviceID }}</span> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    roomID: {},
    info: {}
  }
}
</script>

<style scoped>
.online-area{
  margin: 30px;
}
.online-item{
  display: inline;
  font-weight: bold;
  font-size: 24px;
}
.online-id{
  display: inline;
  font-size: 13px;
}
</style>
